/**
 * List test Adapters to abstract common unit test actions away from the implementation details.
 */

import { fireEvent, RenderResult } from '@testing-library/preact';

export const mouseItemSelection = (element: HTMLElement, options?: Record<string, unknown>) => {
  fireEvent.click(element, options);
};

export const mouseCheckboxSelection = (element: HTMLElement, options?: Record<string, unknown>) => {
  const checkbox = element.querySelector('[type=checkbox]');
  if (checkbox) {
    fireEvent.click(checkbox, options);
  } else {
    throw new Error('checkbox not found!');
  }
};

export const getRoot = async (list: RenderResult, role = 'grid') => {
  return list.findByRole(role);
};

export const getItems = async (list: RenderResult, role = 'row') => {
  return list.findAllByRole(role);
};

export const getContents = async (list: RenderResult, role = 'gridcell') => {
  return list.findAllByRole(role);
};
